module.exports = __webpack_public_path__ + "static/media/Menu.f1748d41.svg";